const currencies = ["USD", "EUR", "COP"]
export default currencies
